import React, { useEffect, useState } from 'react';

const DebugPopup = ({ isOpen, onClose, data, darkMode }) => {
  const [localData, setLocalData] = useState(data || {});
  const [isCollapsed, setIsCollapsed] = useState(false);
  
  // Data değiştiğinde local state'i güncelle - konsol log kaldırıldı
  useEffect(() => {
    if (data) {
      setLocalData(data);
    }
  }, [data]);
  
  if (!isOpen) return null;

  // Sonuçların değişimini görsel olarak vurgula
  const highlightIfChanged = (value, prevValue) => {
    if (prevValue !== undefined && value !== prevValue) {
      return darkMode ? "animate-pulse bg-yellow-900/50" : "animate-pulse bg-yellow-100";
    }
    return "";
  };

  return (
    <div 
      className="fixed top-0 right-0 bottom-0 z-50 flex justify-end pointer-events-none" 
      style={{ width: isCollapsed ? '50px' : '400px' }}
    >
      <div 
        className={`${darkMode ? 'bg-gray-800 text-white' : 'bg-white text-gray-800'} 
          rounded-l-lg shadow-lg overflow-auto h-full pointer-events-auto`}
        style={{ maxWidth: isCollapsed ? '50px' : '400px', transition: 'max-width 0.3s ease' }}
      >
        <div className={`sticky top-0 ${darkMode ? 'bg-blue-700' : 'bg-blue-600'} text-white px-4 py-3 flex justify-between items-center`}>
          <button
            onClick={() => setIsCollapsed(!isCollapsed)}
            className="mr-2 hover:bg-blue-800 rounded-full p-1 transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
                d={isCollapsed ? "M13 5l7 7-7 7" : "M11 19l-7-7 7-7"} />
            </svg>
          </button>
          
          {!isCollapsed && (
            <>
              <h2 className="text-lg font-semibold flex-1 text-center">Hesaplama Detayları</h2>
              <button 
                onClick={onClose}
                className="hover:bg-blue-800 rounded-full p-1 transition-colors"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </>
          )}
        </div>
        
        {!isCollapsed && (
          <div className="p-4">
            <div className="space-y-4">
              <div>
                <h3 className={`text-lg font-semibold mb-2 ${darkMode ? 'text-blue-400' : 'text-blue-600'}`}>
                  Giriş Parametreleri
                </h3>
                <div className={`${darkMode ? 'bg-gray-700' : 'bg-gray-50'} rounded p-3`}>
                  <h4 className={`font-medium mb-1 ${darkMode ? 'text-gray-200' : 'text-gray-700'}`}>
                    Sistem Parametreleri:
                  </h4>
                  <div className="grid grid-cols-2 gap-2 mb-3">
                    <div className={`p-2 ${darkMode ? 'bg-blue-900/30' : 'bg-blue-50'} rounded`}>
                      <span className={`text-xs ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                        Isıtma Kapasitesi:
                      </span>
                      <div className={`text-lg font-bold ${darkMode ? 'text-blue-300' : 'text-blue-700'}`}>
                        {localData.system?.heatingCapacity?.toFixed(0) || 'N/A'} kW
                      </div>
                    </div>
                    <div className={`p-2 ${darkMode ? 'bg-blue-900/30' : 'bg-blue-50'} rounded`}>
                      <span className={`text-xs ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                        Isıtma Sıcaklık:
                      </span>
                      <div className={`text-lg font-bold ${darkMode ? 'text-blue-300' : 'text-blue-700'}`}>
                        {localData.system?.heatingTemperature || 'N/A'}°C
                      </div>
                    </div>
                    <div className={`p-2 ${darkMode ? 'bg-blue-900/30' : 'bg-blue-50'} rounded`}>
                      <span className={`text-xs ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                        Soğutma Kapasitesi:
                      </span>
                      <div className={`text-lg font-bold ${darkMode ? 'text-blue-300' : 'text-blue-700'}`}>
                        {localData.system?.coolingCapacity?.toFixed(0) || 'N/A'} kW
                      </div>
                    </div>
                    <div className={`p-2 ${darkMode ? 'bg-blue-900/30' : 'bg-blue-50'} rounded`}>
                      <span className={`text-xs ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                        Soğutma Sıcaklık:
                      </span>
                      <div className={`text-lg font-bold ${darkMode ? 'text-blue-300' : 'text-blue-700'}`}>
                        {localData.system?.coolingTemperature || 'N/A'}°C
                      </div>
                    </div>
                    <div className={`p-2 ${darkMode ? 'bg-blue-900/30' : 'bg-blue-50'} rounded`}>
                      <span className={`text-xs ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                        Chiller COP:
                      </span>
                      <div className={`text-lg font-bold ${darkMode ? 'text-blue-300' : 'text-blue-700'}`}>
                        {localData.system?.chillerCop?.toFixed(2) || 'N/A'}
                      </div>
                    </div>
                    <div className={`p-2 ${darkMode ? 'bg-blue-900/30' : 'bg-blue-50'} rounded`}>
                      <span className={`text-xs ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                        Çalışma Saati:
                      </span>
                      <div className={`text-lg font-bold ${darkMode ? 'text-blue-300' : 'text-blue-700'}`}>
                        {localData.system?.workingHours || 'N/A'} saat
                      </div>
                    </div>
                  </div>
                  
                  <h4 className={`font-medium mt-3 mb-1 ${darkMode ? 'text-gray-200' : 'text-gray-700'}`}>
                    Global Parametreler:
                  </h4>
                  <div className="grid grid-cols-2 gap-2 mb-3">
                    <div className={`p-2 ${darkMode ? 'bg-gray-800' : 'bg-gray-100'} rounded`}>
                      <span className={`text-xs ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                        Baz COP:
                      </span>
                      <div className={`font-bold ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                        {localData.globalParams?.baseCOP || 'N/A'}
                      </div>
                    </div>
                    <div className={`p-2 ${darkMode ? 'bg-gray-800' : 'bg-gray-100'} rounded`}>
                      <span className={`text-xs ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                        Elektrik Fiyatı:
                      </span>
                      <div className={`font-bold ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                        {localData.globalParams?.electricityPrice || 'N/A'} TL/kWh
                      </div>
                    </div>
                    <div className={`p-2 ${darkMode ? 'bg-gray-800' : 'bg-gray-100'} rounded`}>
                      <span className={`text-xs ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                        Doğalgaz Fiyatı:
                      </span>
                      <div className={`font-bold ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                        {localData.globalParams?.gasPrice || 'N/A'} TL/kWh
                      </div>
                    </div>
                   
                  </div>
                  
                  <h4 className={`font-medium mt-3 mb-1 ${darkMode ? 'text-gray-200' : 'text-gray-700'}`}>
                    Diğer Ayarlar:
                  </h4>
                  <div className={`flex items-center p-2 ${darkMode ? 'bg-yellow-900/30' : 'bg-yellow-50'} rounded mb-2`}>
                    <span className={`text-xs ${darkMode ? 'text-gray-400' : 'text-gray-500'} mr-2`}>
                      Güneş Enerjisi:
                    </span>
                    <span className={`font-bold ${
                      localData.solarEnabled 
                        ? darkMode ? 'text-yellow-300' : 'text-yellow-600'
                        : darkMode ? 'text-gray-300' : 'text-gray-700'
                    }`}>
                      {localData.solarEnabled ? 'Aktif ✅' : 'Pasif ❌'}
                    </span>
                  </div>
                  <div className={`flex items-center p-2 ${darkMode ? 'bg-purple-900/30' : 'bg-purple-50'} rounded`}>
                    <span className={`text-xs ${darkMode ? 'text-gray-400' : 'text-gray-500'} mr-2`}>
                      Euro Kuru:
                    </span>
                    <span className={`font-bold ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                      {localData.eurRate || 'N/A'} TL
                    </span>
                  </div>
                </div>
              </div>
              
              <div>
                <h3 className={`text-lg font-semibold mb-2 ${darkMode ? 'text-green-400' : 'text-green-600'}`}>
                  Hesaplama Sonuçları
                </h3>
                <div className={`${darkMode ? 'bg-gray-700' : 'bg-gray-50'} rounded p-3`}>
                  <h4 className={`font-medium mb-1 ${darkMode ? 'text-gray-200' : 'text-gray-700'}`}>
                    Hesaplanan Değerler:
                  </h4>
                  <div className="grid grid-cols-2 gap-2">
                    <div className={`p-2 ${darkMode ? 'bg-green-900/30' : 'bg-green-50'} rounded`}>
                      <span className={`text-xs ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                        Cop Değeri:
                      </span>
                      <div className={`text-lg font-bold ${darkMode ? 'text-green-300' : 'text-green-700'} transition-all duration-500 ${
                        highlightIfChanged(localData.results?.cop)
                      }`}>
                        {localData.results?.cop?.toFixed(2) || 'N/A'}
                      </div>
                    </div>
                    <div className={`p-2 ${darkMode ? 'bg-blue-900/30' : 'bg-blue-50'} rounded`}>
                      <span className={`text-xs ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                        Enerji Tüketimi:
                      </span>
                      <div className={`text-lg font-bold ${darkMode ? 'text-blue-300' : 'text-blue-700'} transition-all duration-500 ${
                        highlightIfChanged(localData.results?.energy)
                      }`}>
                        {localData.results?.energy?.toFixed(1) || 'N/A'} MWh
                      </div>
                    </div>
                    <div className={`p-2 ${darkMode ? 'bg-yellow-900/30' : 'bg-yellow-50'} rounded`}>
                      <span className={`text-xs ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                        Tasarruf:
                      </span>
                      <div className={`text-lg font-bold ${darkMode ? 'text-yellow-300' : 'text-yellow-700'} transition-all duration-500 ${
                        highlightIfChanged(localData.results?.savings)
                      }`}>
                        {localData.results?.savings?.toFixed(2) || 'N/A'} K €
                      </div>
                    </div>
                    <div className={`p-2 ${darkMode ? 'bg-purple-900/30' : 'bg-purple-50'} rounded`}>
                      <span className={`text-xs ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                        CO2 Azaltımı:
                      </span>
                      <div className={`text-lg font-bold ${darkMode ? 'text-purple-300' : 'text-purple-700'} transition-all duration-500 ${
                        highlightIfChanged(localData.results?.co2)
                      }`}>
                        {localData.results?.co2?.toFixed(1) || 'N/A'} ton
                      </div>
                    </div>
                  </div>
                  
                  <div className={`mt-4 p-3 ${darkMode ? 'bg-gray-800' : 'bg-gray-100'} rounded-lg overflow-auto max-h-60`}>
                    <h4 className={`font-medium mb-2 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                      Tüm Hesaplama Sonuçları:
                    </h4>
                    <div className="overflow-x-auto">
                      <table className="min-w-full text-xs">
                        <thead>
                          <tr className={`${darkMode ? 'bg-gray-700' : 'bg-gray-200'}`}>
                            <th className="p-2 text-left">Parametre</th>
                            <th className="p-2 text-right">Değer</th>
                          </tr>
                        </thead>
                        <tbody>
                          {localData.results && Object.entries(localData.results).map(([key, value]) => (
                            <tr key={key} className={`border-t ${darkMode ? 'border-gray-600' : 'border-gray-300'}`}>
                              <td className={`p-2 text-left font-medium ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                                {key}
                              </td>
                              <td className={`p-2 text-right font-mono ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                                {typeof value === 'number' ? 
                                  value.toLocaleString('tr-TR', {maximumFractionDigits: 2}) : 
                                  String(value)}
                              </td>
                            </tr>
                          ))}
                          {!localData.results && (
                            <tr>
                              <td colSpan={2} className={`p-2 text-center ${darkMode ? 'text-gray-500' : 'text-gray-500'}`}>
                                Sonuç bulunamadı
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DebugPopup;